import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Header.css';

const Header = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  
  return (
    <header className={isScrolled ? 'scrolled' : ''}>
      <div className="container">
        <div className="logo">
          <h1>Heal<span>AI</span></h1>
        </div>
        <nav>
          <ul className={isMenuOpen ? 'active' : ''}>
            <li>
              <Link
                to="home"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className={activeSection === 'home' ? 'active' : ''}
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="about"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className={activeSection === 'about' ? 'active' : ''}
                onClick={closeMenu}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="solution"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className={activeSection === 'solution' ? 'active' : ''}
                onClick={closeMenu}
              >
                Our Solution
              </Link>
            </li>
            <li>
              <Link
                to="how-it-works"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className={activeSection === 'how-it-works' ? 'active' : ''}
                onClick={closeMenu}
              >
                How It Works
              </Link>
            </li>
            <li>
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                className={activeSection === 'contact' ? 'active' : ''}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
